export default __webpack_public_path__ + "static/media/cabinetdoorafter.f1b9ef73.jpg";